import cardTpl from './general-card.tpl.html';

/**
 * Displays data in a regular booking format like persons and locations
 */
class GeneralCardComponent {

  constructor($window, $log) {
    'ngInject';

    this.$log = $log;


    this.infoCallback = null;
    this.showInfo = false;

    /**
     * Should the card display as active
     *
     * @type {boolean}
     */
    this.active = false;

    /**
     * Main title of the card
     *
     * @type {string}
     */
    this.title = "Placeholder";
    /**
     * Subtitle of the card, in a smaller font under title
     *
     * @type {?String}
     */
    this.subtitle = null;

    /**
     * Icon that is displayed for this card
     * @type {?String}
     */
    this.icon = null;

  }

  $onInit() {
  }

  onInfoClicked(event) {
    event.stopPropagation();
    this.infoCallback(null);
  }

}

const config = {
  templateUrl: cardTpl,
  controller: GeneralCardComponent,
  bindings: {
    title: '@',
    subtitle: '@?',
    icon: '@?',
    showInfo: '<?',
    infoCallback: '&?',
  }
};

const mod = angular.module('app.generalCard', [
  ])
    .component('generalCard', config)
;

export default mod.name;
